import { Component, computed, inject } from '@angular/core';
import { BasketService } from '@basket';
import { CatalogueService } from '@catalogue';
import {
  DescriptionListComponent,
  DescriptionListItemComponent,
} from '@components';
import { CheckoutService } from '@features/checkout';
import {
  CurrencyFormatPipe,
  provideTranslationDictionaryMapping,
  TranslatePipe,
} from '@i18n';
import { format } from 'date-fns';
import { translation } from '../../i18n/translation.constant';

@Component({
  selector: 'app-protected-appliance-summary',
  templateUrl: './protected-appliance-summary.component.html',
  styleUrl: './protected-appliance-summary.component.scss',
  imports: [
    CurrencyFormatPipe,
    DescriptionListComponent,
    DescriptionListItemComponent,
    TranslatePipe,
  ],
  providers: [provideTranslationDictionaryMapping(translation)],
})
export class ProtectedApplianceSummaryComponent {
  private readonly basketService = inject(BasketService);
  private readonly catalogueService = inject(CatalogueService);
  private readonly checkoutService = inject(CheckoutService);

  readonly appliance = this.catalogueService.steppedFormAppliance;
  readonly appliancePurchaseDate = computed(() =>
    format(
      this.catalogueService.selectedAppliancePurchaseDate(),
      'do MMMM yyyy',
    ),
  );
  readonly numberOfDiscountedMonths =
    this.basketService.basketItemQuoteFreeMonths;
  readonly hasDiscountedMonths = this.basketService.basketItemQuoteHasPromo;
  readonly quoteMonthlyPayment =
    this.basketService.basketItemQuoteDetailsPaymentOption;
  readonly planNumber = this.checkoutService.planNumber;
  readonly planStartDate = this.checkoutService.planStartDate;
}
